import { render, staticRenderFns } from "./RouteEditModal.vue?vue&type=template&id=5197fb07&scoped=true"
import script from "./RouteEditModal.vue?vue&type=script&lang=ts"
export * from "./RouteEditModal.vue?vue&type=script&lang=ts"
import style0 from "./RouteEditModal.vue?vue&type=style&index=0&id=5197fb07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5197fb07",
  null
  
)

export default component.exports